import { Row, Col, FormGroup, Input } from "reactstrap"

import { CustomAutocomplete } from "common"
import { FormControl, Grid, TextField, Typography } from "@mui/material"

const ModalFormMora = ({useFetchInit}) => {

    const {
        //------------- globalStates
        globalStates,
        //------------- Formularios
        Forms,
        //------------- FetchData
        FetchData,

    } = useFetchInit



    const { FormRequestGlobal } = Forms
    const { formState, onInputChange,  onSelectSearchChange } = FormRequestGlobal

    return (
        <div className='content'>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ marginBottom: 2, marginTop: 2 }}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Typography variant='subtitle2' sx={{ color: 'red' }}>
                    <strong>Recargo por Mora</strong>
                  </Typography>
                  <div className="border-bottom border-dark"></div>
                </Grid>
                <Grid item xs={12} sm={12} md={2} lg={2} sx={{mt:2}}>
                    <FormControl fullWidth>
                        <label htmlFor="dias_atraso" style={{ color: 'red' }}>Dias de atraso</label>
                        <TextField
                            id='dias_atraso'
                            name='dias_atraso'
                            size='small'
                            hiddenLabel
                            value={ formState.dias_atraso }
                            onChange={ onInputChange }
                            placeholder='Dias de Atraso'
                            variant={'filled'}
                            InputProps={{
                                readOnly: true
                            }}
                            type='number'
                        />
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={3} lg={3} sx={{mt:2}}>
                    <FormControl fullWidth>
                        <label htmlFor="pago_dias_atraso" style={{ color: 'red' }}>Pago por dias de atraso</label>
                        <TextField
                            id='pago_dias_atraso'
                            name='pago_dias_atraso'
                            size='small'
                            hiddenLabel
                            value={ formState.pago_dias_atraso }
                            onChange={ onInputChange }
                            placeholder='Dias de Atraso'
                            variant={'filled'}
                            InputProps={{
                                readOnly: true
                            }}
                            type='number'
                        />
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={3} lg={3} sx={{mt:2}}>
                    <FormControl fullWidth>
                        <label htmlFor="interes_mora" style={{ color: 'red' }}>Interes mora</label>
                        <TextField
                            id='interes_mora'
                            name='interes_mora'
                            size='small'
                            hiddenLabel
                            value={ formState.interes_mora }
                            onChange={ onInputChange }
                            placeholder='Dias de Atraso'
                            variant={'filled'}
                            InputProps={{
                                readOnly: true
                            }}
                            type='number'
                        />
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={4} lg={4} sx={{mt:2}}>
                    <FormControl fullWidth>
                        <label htmlFor="total_mora" style={{ color: 'red' }}>Total Mora</label>
                        <TextField
                            id='total_mora'
                            name='total_mora'
                            size='small'
                            hiddenLabel
                            value={ formState.total_mora }
                            onChange={ onInputChange }
                            placeholder='Dias de Atraso'
                            variant={'filled'}
                            InputProps={{
                                readOnly: true
                            }}
                            type='number'
                        />
                    </FormControl>
                </Grid>
            </Grid>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>

            </Grid>
        </div>

    )
}

export{
    ModalFormMora
}